module.exports = __webpack_public_path__ + "static/media/members.567753bb.svg";